var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgJs = function SvgJs(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F7CC50",
    d: "M9.387 9.85a1.86 1.86 0 0 0 1.688 1.039c.71 0 1.162-.354 1.162-.844 0-.587-.465-.795-1.245-1.136l-.428-.184C9.329 8.2 8.509 7.54 8.509 6.147c0-1.283.978-2.26 2.506-2.26A2.53 2.53 0 0 1 13.45 5.26l-1.332.855a1.16 1.16 0 0 0-1.1-.733.744.744 0 0 0-.82.733c0 .514.319.721 1.05 1.04l.429.182c1.454.624 2.274 1.26 2.274 2.688 0 1.541-1.21 2.385-2.835 2.385a3.29 3.29 0 0 1-3.118-1.75zM3.343 10c.27.477.514.88 1.1.88.562 0 .917-.22.917-1.075V3.987h1.711V9.83c0 1.771-1.039 2.578-2.555 2.578a2.66 2.66 0 0 1-2.566-1.563z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgJs);
export { ForwardRef as ReactComponent };